export const rampPlansActions = {
  CLICK_RAMP_PLAN_COPY: "CLICK_RAMP_PLAN_COPY",
  CLICK_RAMP_PLAN_CREATE: "CLICK_RAMP_PLAN_CREATE",
  CLICK_RAMP_PLAN_DELETE: "CLICK_RAMP_PLAN_DELETE",
  CLICK_RAMP_PLAN_DOWNLOAD_CSV: "CLICK_RAMP_PLAN_DOWNLOAD_CSV",
  CLICK_RAMP_PLAN_OPEN_CREATE_FORM: "CLICK_RAMP_PLAN_OPEN_CREATE_FORM",
  CLICK_RAMP_PLAN_UPDATE: "CLICK_RAMP_PLAN_UPDATE",
  SELECT_RAMP_PLAN_TO_DISPLAY: "SELECT_RAMP_PLAN_TO_DISPLAY",
} as const;
